import styled from "styled-components";
import {motion} from 'framer-motion';

//for navbar and get in touch links
export const IconsWrap = styled.ul`
  display: flex;
  li{
    list-style: none;
    margin-right: 1.5rem;
  }
`;

export const TitleWrapper = styled(motion.div)`
    height: 100vh;
    display: flex;
    width: 100vw;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    position: fixed;
    
`;

export const TitleDesc = styled(motion.div)`
    display: flex;
    flex-direction: column;
    position: absolute;
    margin-left: 15%;
    top: 50%;
    transform: translate(0%, -50%);
    z-index: 100;
    
    .redline1{
        border-bottom: 4px solid var(--secondary);
        border-radius: 10px;
        width: 6rem;
        margin-top: 1rem;
    }
    .redline2{
        border-bottom: 4px solid var(--secondary);
        border-radius: 10px;
        width: 6rem;
        margin: 0.7rem 0 0 2.7rem ;
    }
    .role{
        margin-top: 3rem;
    }

    @media only screen and (max-width: 500px){

        top: unset;
        bottom: 5rem;
        margin-left: 3rem;

        

        .redline1{
            border-bottom: 2px solid var(--secondary);
            border-radius: 10px;
            width: 4rem;
            margin-top: 0.5rem;
        }
        .redline2{
            border-bottom: 2px solid var(--secondary);
            border-radius: 10px;
            width: 4rem;
            margin: 0.4rem 0 0 2.7rem ;
        }
        .role{
          margin-top: 1rem;
        }
    }

`;


//DETAILS COMPONENTS
export const FullWrap  = styled.div`
    width: 100%;
`

export const DetailContainer = styled.div`
    width: 100%;
    height: 100vh;
    background-color: var(--darkBlue);
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
`;


export const DetailDesc = styled.div`
    display: flex;
    flex-direction: column;
    position: absolute;
    margin-left: 15%;
    top: 50%;
    transform: translate(0%, -50%);
    z-index: 100;
    
    .redline1{
        border-bottom: 4px solid var(--secondary);
        border-radius: 10px;
        width: 6rem;
        margin-top: 1rem;
    }
    .redline2{
        border-bottom: 4px solid var(--secondary);
        border-radius: 10px;
        width: 6rem;
        margin: 0.7rem 0 0 2.7rem ;
    }
    .role{
        margin-top: 3rem;
    }

    @media only screen and (max-width: 500px){
        top: 70%;
    }


`;

export const LowerSec = styled.div`
    width: 100%;
    padding: 8rem 0rem;
    background-color: var(--white);

    .scroll-to-top{
        display: inline-block;
        /* border: 2px solid red; */
        position: fixed;
        bottom: 100px;
        right: 30px;
    }

`